"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMoneyFields = useMoneyFields;
var _react = require("react");
var _reduxForm = require("redux-form");
var _reactRedux = require("react-redux");
var _bignumber = require("bignumber.js");
var _useFormValues = require("./useFormValues");
var _instrumentPositionSelectors = require("../../../redux/selectors/instrumentPositionSelectors");
var _useOrderPrice = require("./useOrderPrice");
var _decimalPlacesHelper = require("../../../helpers/decimalPlaces/decimalPlacesHelper");
var _orderEntryFormConstants = require("../../../constants/sendOrder/orderEntryFormConstants");
function useMoneyFields(formName, maxQuantity) {
  var hasCredit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var dispatch = (0, _reactRedux.useDispatch)();
  var price = (0, _useOrderPrice.useOrderPrice)(formName);
  var instrument = (0, _reactRedux.useSelector)(_instrumentPositionSelectors.selectedInstrumentSelector);
  var formValues = (0, _useFormValues.useFormValues)(formName);
  var anchoredField = formValues.anchoredField,
    side = formValues.side;
  var isBuy = side === _orderEntryFormConstants.buyValue;
  var isDisabled = !maxQuantity && !hasCredit;
  var valueDP = instrument ? (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement) : 2;
  var quantityDP = instrument ? (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.QuantityIncrement) : 2;
  var onChange = (0, _react.useCallback)(function (key, value) {
    return dispatch((0, _reduxForm.change)(formName, key, value));
  }, [dispatch, formName]);

  //#region Sync values of the quantity and value inputs based on the anchored field (currently focused input)
  (0, _react.useEffect)(function () {
    if (anchoredField === 'value') {
      var quantity = (formValues.value || 0) / price;
      if (typeof quantity === 'number' && !Number.isNaN(quantity) && Number.isFinite(quantity) && quantity !== formValues.quantity) {
        onChange('quantity', quantity);
      }
    }
  }, [anchoredField, price, formValues.value, formValues.quantity, quantityDP, onChange]);
  (0, _react.useEffect)(function () {
    if (anchoredField === 'quantity') {
      var value = price * (formValues.quantity || 0);
      if (typeof value === 'number' && !Number.isNaN(value) && value !== formValues.value) {
        onChange('value', value);
      }
    }
  }, [anchoredField, price, formValues.quantity, formValues.value, valueDP, onChange]);
  //#endregion

  //#region Slider value and change handler
  var sliderValue = (0, _react.useMemo)(function () {
    if (hasCredit) {
      return 0;
    }
    var quantity = new _bignumber.BigNumber(formValues.quantity || 0);
    var maxAmount = maxQuantity;
    if (maxAmount > 0 && quantity.gt(0)) {
      var newSliderValue = quantity.div(maxAmount).times(100);
      return Math.min(Math.max(newSliderValue.dp(2, _bignumber.BigNumber.ROUND_HALF_UP).toNumber(), 0), 100);
    }
    return 0;
  }, [formValues.quantity, maxQuantity]);
  var onSliderChange = (0, _react.useCallback)(function (value) {
    var percentage = parseFloat(value) || 0;
    var amount = maxQuantity * (percentage / 100);
    if (anchoredField !== 'quantity') {
      onChange('anchoredField', 'quantity');
    }
    onChange('quantity', new _bignumber.BigNumber(amount).dp(quantityDP).toNumber());
  }, [maxQuantity, onChange, anchoredField, quantityDP]);
  //#endregion

  return {
    formValues: formValues,
    sliderValue: sliderValue,
    onSliderChange: onSliderChange,
    valueDP: valueDP,
    quantityDP: quantityDP,
    onChange: onChange,
    instrument: instrument,
    isBuy: isBuy,
    isDisabled: isDisabled
  };
}